/**
 * Shared helpers for resource modules.
 *
 * `NoContentSchema` matches 204 responses (body === undefined) — used by
 * DELETEs and the POST /v1/admin/users/{userId}/reset-password action.
 */
import { z } from 'zod';
export const NoContentSchema = z.undefined();
//# sourceMappingURL=_helpers.js.map